import { NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { UrlNavigatorService } from '@shared/services';
import { GenericLinkComponent } from '@spartacus/storefront';
import { SafeUrlPipe } from '../../pipes';
import { SdvorLinkComponent } from '../link';

@Component({
  selector: 'sd-generic-link',
  templateUrl: './generic-link.component.html',
  styleUrls: ['./generic-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgTemplateOutlet, RouterLink, RouterLinkActive, SafeUrlPipe, SdvorLinkComponent],
})
export class SdvorGenericLinkComponent extends GenericLinkComponent implements OnChanges {
  @Input() routerLinkActive: string | string[] = '';

  constructor(
    router: Router,
    private urlNavigatorService: UrlNavigatorService,
  ) {
    super(router);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.url && typeof changes.url.currentValue === 'string') {
      changes.url.currentValue = this.urlNavigatorService.removeInternalPrefix(changes.url.currentValue);
      this.url = changes.url.currentValue;
    }

    super.ngOnChanges(changes);
  }

  isExternalUrl(): boolean {
    return typeof this.url === 'string' && this.urlNavigatorService.isExternal(this.url);
  }
}
